// CSS imports for webpack processing - @layer統制版
import '../css/app.css';

import { initApp } from './app/init-app.js';
import { GameStatus } from './core/constants.js';
import gameState from './core/game-state.js';
import { STATE_PATHS } from './shared/constants/state-paths.js';
// Board instance is managed by gameControls.js
// 🎯 自動unregister機能を削除済み
import { MinimalErrorTracker } from './shared/log.js';
// Side-effect imports
// event-handlers.js は不要になったため削除
import './platform/resize.js';
import './presentation/input/start-button.js';

// Application initialization
const initResult = await initApp();
if (!initResult.success) {
  MinimalErrorTracker.critical(
    'INIT_APP',
    `Application initialization failed: ${initResult.error}`,
  );
}

// Initialize unified animation management system
// 🎯 自動unregister機能を削除済み

// Initialize status on boot: show blank board
gameState.setState(STATE_PATHS.CORE_STATUS, GameStatus.Title);
